import script from "./CheckinFeedAuthor.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinFeedAuthor.vue?vue&type=script&setup=true&lang=js"

import "./CheckinFeedAuthor.vue?vue&type=style&index=0&id=f508d5d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f508d5d0"]])

export default __exports__